import { render, staticRenderFns } from "./ThreatAlertsTable.vue?vue&type=template&id=f64ed492&scoped=true&"
import script from "./ThreatAlertsTable.vue?vue&type=script&lang=js&"
export * from "./ThreatAlertsTable.vue?vue&type=script&lang=js&"
import style0 from "./ThreatAlertsTable.vue?vue&type=style&index=0&id=f64ed492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64ed492",
  null
  
)

export default component.exports